import {
  calculateCapacity,
  LEGACY_PRODUCT_TYPE,
  LEGACY_TICK_RATE_HZ,
  type ServerSummary,
} from "@woven/contracts";

export function serverCapacity(server: ServerSummary) {
  const productType = server.productType ?? LEGACY_PRODUCT_TYPE;
  const tickRateHz = server.tickRateHz ?? LEGACY_TICK_RATE_HZ;
  const allocatedCapacity =
    server.allocatedCapacity ??
    (server.allocatedCcu === undefined ? null : calculateCapacity(tickRateHz, server.allocatedCcu));
  const reservedCapacity = server.reservedCapacity ?? allocatedCapacity;
  const pending = server.capacityChangePending === true;
  return {
    productType,
    tickRateHz,
    allocatedCapacity,
    reservedCapacity,
    pending,
    pendingCapacity: server.pendingCapacity,
    legacy: server.productType === undefined || server.tickRateHz === undefined,
  };
}

export function canEditServerCapacity(server: ServerSummary): boolean {
  const bound = Boolean(
    server.connection?.endpoint ||
    server.connection?.namespaceId ||
    server.connection?.sessionId ||
    server.connection?.tokenStatus === "active"
  );
  return Boolean(
    server.generation &&
    !server.lifecycle?.deleteIntent &&
    (server.status === "running" || (server.status === "pending" && !bound))
  );
}

export function temporaryServerCapacity(
  server: ServerSummary,
  tickRateHz: number,
  targetCapacity: number
): number | null {
  if (server.status !== "running" && !server.capacityChangePending) return targetCapacity;
  const current = serverCapacity(server);
  if (current.allocatedCapacity === null || server.allocatedCcu === undefined) return null;
  return Math.max(
    current.allocatedCapacity,
    targetCapacity,
    calculateCapacity(tickRateHz, server.allocatedCcu),
    current.pending ? (current.reservedCapacity ?? 0) : 0
  );
}
